import React, { useState, useEffect } from 'react';
import './internos.css';
import VisibleAccess from '../../permissions/VisibleAccess';
import { useInternals } from '../../context/internalContext';
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faSave } from '@fortawesome/free-solid-svg-icons';
import useSubmitLock from '../../utils/useSubmitLock';

function InternalPhone({ internalId, internalUnit }) {
  const { createPhone, updatePhone, listPhone } = useInternals();

  const [phones, setPhones] = useState([]);
  const [phoneData, setPhoneData] = useState({
    name: '',
    title: '',
    number: '',
    person: internalId,
  });
  const [isEditing, setIsEditing] = useState(false);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  useEffect(() => {
    const fetchPhones = async () => {
      if (!internalId) return;
  
      const phones = await listPhone(internalId);
      setPhones(phones || []); 
    };
  
    fetchPhones();
  }, [internalId, listPhone]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPhoneData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        if (isEditing) {
          await updatePhone(phoneData);
        } else {
          await createPhone(phoneData);
        }

        // Resetar os campos do formulário após o envio
        setPhoneData({
          name: '',
          title: '',
          number: '',
          person: internalId,
        });
        setIsEditing(false);

        // Atualizar a lista de telefones
        const updatedPhones = await listPhone(internalId);
        setPhones(updatedPhones || []);
      } catch (error) {
        console.error('Erro ao salvar telefone:', error);
      }
    });
  };

  const handleEdit = (phone) => {
    setPhoneData({
      ...phone,
      person: internalId, // Garante que o ID do interno esteja correto
    });
    setIsEditing(true);
  };

  return (
    <div className='content-table'>
      {phones.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Título</th>
              <th>Número</th>
              <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                <VisibleAccess compareField="unit" compareValues={[internalUnit]}>
                  <th>Editar</th>
                </VisibleAccess>
              </VisibleAccess>
            </tr>
          </thead>
          <tbody>
            {phones.map(phone => (
              <tr key={phone.id}>
                <td>{phone.name}</td>
                <td>{phone.title}</td>
                <td>{phone.number}</td>
                <td>
                  <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                    <VisibleAccess compareField="unit" compareValues={[internalUnit]}>
                      <button className='btnEditar' onClick={() => handleEdit(phone)}>
                        <FontAwesomeIcon icon={faPencilAlt} />
                      </button>
                    </VisibleAccess>
                  </VisibleAccess>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Nenhum contato cadastrado</p>
      )}

      <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
        <VisibleAccess compareField="unit" compareValues={[internalUnit]}>
          <h4 className='h4-title'>Adicionar novo</h4>
          <form onSubmit={handleSubmit} className="inline-form">
            <div className="form-edit">
              <label>Nome</label>
              <input
                type="text"
                name="name"
                value={phoneData.name}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>
            <div className="form-edit">
              <label>Título</label>
              <input
                type="text"
                name="title"
                value={phoneData.title}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>
            <div className="form-edit">
              <label>Número</label>
              <FormattedInput
                type="telefone"
                name="number"
                value={phoneData.number}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>
            <button className='btn-edit-inline' type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : isEditing ? <FontAwesomeIcon icon={faSave} /> : 'Salvar'}
            </button>
          </form>
        </VisibleAccess>
      </VisibleAccess>
    </div>
  );
}

export default InternalPhone;
